/**
 * What a customer sees for the price of the package the admin granted:
 *   ar «50 ر.س» / «15 د.أ» / «500 ج.م»      en "SAR 50" / "JOD 15" / "EGP 500"
 * Latin digits (platform rule), trailing zeros trimmed, JOD keeps up to 3 decimals.
 * Returns '' when there is no stored currency: legacy rows show no amount at all.
 */
const CUR = {
  SAR: { decimals: 2, ar: 'ر.س', en: 'SAR' },
  JOD: { decimals: 3, ar: 'د.أ', en: 'JOD' },
  EGP: { decimals: 2, ar: 'ج.م', en: 'EGP' },
};

export function formatMoney(amount, currency, lang = 'en') {
  const c = CUR[String(currency || '').toUpperCase()];
  if (!c || amount === null || amount === undefined || amount === '') return '';
  const n = Number(amount).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: c.decimals });
  return String(lang).startsWith('ar') ? `${n} ${c.ar}` : `${c.en} ${n}`;
}
